import { css } from '@emotion/react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { CONFIG } from '~/_shared/constants/config';
import type { Theme } from '~/_shared/themes/theme.model';
import { ChartsGalleryComponent } from '~/charts/chartsGallery.component';
import { DataTableSplitScreenContainer } from '~/data/table/dataTableSplitScreen.container';
import { useMapIdSelector } from '~/store/selectors/useMapIdSelector';
import { setHighlightStatsBoundaryGroup } from '~/store/stats/stats.actionCreators';
import { useSplitPanelState } from '~/store/userData/settings/splitPanel/useSplitPanelState';
import { MapPageSplitScreenTab } from './mapPageSplitScreen.types';
import { useMapPageChartItems } from './useMapPageChartItems';

export const wrapperStyle = (theme: Theme) => css({
  borderBottom: `1px solid ${theme.borderColors.primary}`,
  height: '100%',
  minHeight: 0,
  flex: '1 1 100%',
  display: 'flex',
  flexDirection: 'column',
});

const chartsGalleryContainerStyle = css({
  padding: 10,
});

export const SplitScreenContent = () => {
  const dispatch = useDispatch();
  const mapId = useMapIdSelector();
  const { tab } = useSplitPanelState(mapId);
  const { chartItems, chartIdToScrollTo } = useMapPageChartItems();

  const onScrolledToChartItem = useCallback(() => {
    dispatch(setHighlightStatsBoundaryGroup(null));
  }, [dispatch]);

  const availableCharts = chartItems.length > 0 && CONFIG.ENABLE_CHARTS;

  return (
    <div css={wrapperStyle}>
      {(!availableCharts || tab === MapPageSplitScreenTab.Spreadsheet) &&
        <DataTableSplitScreenContainer />
      }
      {availableCharts && tab === MapPageSplitScreenTab.Chart && (
        <ChartsGalleryComponent
          css={chartsGalleryContainerStyle}
          chartItems={chartItems}
          scrollToChartItemId={chartIdToScrollTo}
          onScrolledToChartItem={onScrolledToChartItem}
        />
      )}
    </div>
  );
};
